<template>
    <div class="side-bar-block">
        <div v-if="isLogin">
            <div class="member-header">
                <div class="member-top">
                    <img src="../../assets/user-head.gif" alt="">
                    <div class="member-right">
                        <div class="member-name">{{$t('message.sideBar.memberName')}}</div>
                        <div class="member-rank-wrapper">
                            <mIcons v-if="memberGradeNum === 1" class="rank-icon" type="crown" size="15" color="silver"/>
                            <mIcons v-if="memberGradeNum === 2" class="rank-icon" type="crown" size="15" color="#0d6fb8"/>
                            <mIcons v-if="memberGradeNum === 3" class="rank-icon" type="crown" size="15" color="gold"/>
                            <div class="member-rank">{{userInfo.grade_name}}</div>
                        </div>
                    </div>

                </div>
                <div class="member-bottom">{{$t('message.sideBar.memberId')}}: {{userInfo.email}}</div>
            </div>

            <div class="line line-wrapper"></div>

            <div class="my-account">
                <div class="title">{{$t('message.sideBar.myAccount')}}</div>
                <!-- <div class="item" @click="gotoPage('CouponList')">{{$t('message.sideBar.coupons')}}</div>
                <div class="item" @click="gotoPage('Integral')">{{$t('message.sideBar.scoreGift')}}</div>
                <div class="item" @click="gotoPage('Guest')">{{$t('message.sideBar.guests')}}</div>
                <div class="item" @click="gotoPage('Feedback')">{{$t('message.sideBar.advice')}}</div>
                <div class="item" @click="showChangePassword">{{$t('message.sideBar.changePassword')}}</div> -->
                <div class="item" @click="showLogoutModal">{{$t('message.sideBar.logout')}}</div>
            </div>

            <!--        退出登录对话框 start -->
            <Modal v-model="isShowLogoutModal" @on-ok="logout">
                <div class="confirm-dialog">
                    <Icon type="md-help-circle" size="40" color="orange"/>
                    <p>{{$t('message.sideBar.logoutModalText')}}</p>
                </div>
            </Modal>
            <!--        退出登录对话框 end -->
        </div>

        <div v-else class="login-block">
            <div class="user-avatar">
                <img src="../../assets/user-head.gif" alt="">
            </div>
            <Button type="primary" @click="showLoginModal">{{$t('message.sideBar.loginButton')}}</Button>

            <!--            登录对话框 start -->
            <LoginModal :is-show-login="isShowLoginModal"
                        @updateShowLoginModalStatus="setIsShowLoginModal"
                        @updateIsLogin="setIsLogin"/>
            <!--            登录对话框 end -->

        </div>

<!--        修改密码对话框 start -->
        <ChangePassword :is-show="isShowChangePassword" @changeShowStatus="changePasswordShowStatus" />
<!--        修改密码对话框 end -->

    </div>
</template>

<script>
  import mIcons from '@/components/m-icons/m-icons.vue';
  import {gotoPage, logout} from "../../common/common";
  import LoginModal from "../LoginModal/LoginModal.vue";
  import {mapMutations, mapState} from "vuex";
  import ChangePassword from "../changePassword/ChangePassword";

  export default {
    name: "SideBar",

    data() {
      return {
        // 是否展示退出登录对话框
        isShowLogoutModal: false,
        // 是否展示登录对话框
        isShowLoginModal: false,
        // 是否展示修改密码对话框
        isShowChangePassword: false,
      }
    },

    created() {
      // 从缓存获取用户信息
      // this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    },

    methods: {

      ...mapMutations([
        // 保存用户信息
        'setUserInfo',
        // 修改登录状态
        'setLoginStatus',
        // 删除订单列表数据
        'delOrderList',
      ]),

      // 展示修改密码对话框
      showChangePassword() {
        this.isShowChangePassword = true;
      },

      // 修改密码对话框状态变化
      changePasswordShowStatus(val) {
        this.isShowChangePassword = val;
      },

      // 页面跳转
      gotoPage(pageName) {
        gotoPage({
          path: pageName
        });
      },

      // 展示登录对话框
      showLoginModal() {
        this.isShowLoginModal = true;
      },

      // 从LoginModal子组件传来的状态值进行修改
      setIsShowLoginModal(val) {
        this.isShowLoginModal = val;
      },

      // 更新登录状态
      setIsLogin(val) {
        // 从缓存获取用户信息, 因为更新登录状态时，本地的userInfo变量不会更新。
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.isLogin = val;
        // 页面重载
        location.reload();
      },

      // 展示退出对话框
      showLogoutModal() {
        this.isShowLogoutModal = true;
      },

      // 退出登录
      logout() {
        logout();
      }

    },

    computed: {

      ...mapState([
        // 是否登录状态
        'isLogin',
        // 用户信息
        'userInfo',
      ]),

      // 会员等级
      memberGradeNum() {
        let memberGrade = this.userInfo.grade_name;
        if (memberGrade === '三级会员') {
          return 3;
        } else if ((memberGrade === '二级会员')) {
          return 2;
        } else {
          return 1;
        }
      },

    },

    components: {
      ChangePassword,
      LoginModal,
      mIcons,
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "SideBar.scss";

</style>
